import { useQuery } from '@tanstack/react-query';
import { get as getShareData } from '@api/sharing';
import { useState } from "react";
import { get } from "lodash";

// get shared data from db and intiate callback with it

function useGetSharedData({ id, applyCallback }) {

  const [ready, setReady] = useState(false);

  const { data, dataUpdatedAt, refetch } = useQuery(['shared', id],
    () => {
      return getShareData(id);
    },
    {
      retry: 1,
      refetchOnWindowFocus: false,
      enabled: false,
      staleTime: Infinity,
      // notifyOnChangeProps: 'tracked',
      select: (response) => {
        return get(response, ['data'], null);
      },
      onError: (err) => {
        console.error('share error', err);
      },
      onSuccess: (data) => {
        // setSharing
        applyCallback(data);
        setReady(true);
      }
    },
  );

  return { ready, refetch, data };
}

export default useGetSharedData;
